import { render, staticRenderFns } from "./MenuSideNav.vue?vue&type=template&id=71eadfaf&scoped=true"
import script from "./MenuSideNav.vue?vue&type=script&lang=js"
export * from "./MenuSideNav.vue?vue&type=script&lang=js"
import style0 from "./MenuSideNav.vue?vue&type=style&index=0&id=71eadfaf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71eadfaf",
  null
  
)

export default component.exports